// ADV-264 — Figma "Konto / Widerruf-Block" at the foot of an order's left column:
//   Aktion     — purchase / financing: the text plus the button that opens WithdrawalModal;
//   Hinweis    — leasing: withdrawn from the lessor directly, so a note without a button;
//   Abgelaufen — the period has run out (never shown yet: the order carries no deadline).
// The cards use the component's "Mobil" layout on desktop as well (Figma instances).
import * as React from 'react';
import { buyingTypeOf, companyName, germanDay, lenderOf, withdrawalDeadline, } from './orderData';
import clockIcon from './icons/withdrawal-clock.svg';
import infoIcon from './icons/withdrawal-info.svg';
const ns = (key) => `MyOrderPage:orders.wd.${key}`;
// company names go into the text as they are (React escapes them; i18next would turn & into &amp;)
const raw = { escapeValue: false };
const blockText = (lead, state, seller, t) => {
    const deadline = withdrawalDeadline(lead);
    if (state === 'notice') {
        return t(ns('leasing'), { lessor: companyName(lenderOf(lead.car, 'leasing', t)), interpolation: raw });
    }
    if (state === 'expired')
        return deadline ? t(ns('expired'), { date: germanDay(deadline) }) : '';
    const parts = [t(ns('action'))];
    if (seller)
        parts.push(t(ns('recipient'), { name: seller.name, interpolation: raw }));
    if (deadline)
        parts.push(t(ns('deadline'), { date: germanDay(deadline) }));
    return parts.join(' ');
};
const WithdrawalBlock = ({ lead, state, seller, t, onOpen }) => (React.createElement("div", { className: `ao-wd ao-wd--${state} ao-wd--${buyingTypeOf(lead)}` },
    state === 'action' ? null : (React.createElement("span", { className: "ao-wd-ic" },
        React.createElement("img", { src: state === 'notice' ? infoIcon : clockIcon, alt: "", width: 20, height: 20 }))),
    React.createElement("div", { className: "ao-wd-text" },
        React.createElement("h3", { className: "ao-wd-title" }, t(ns('title'))),
        React.createElement("p", { className: "ao-wd-desc" }, blockText(lead, state, seller, t))),
    state === 'action' ? (React.createElement("button", { type: "button", className: "ao-wd-btn", onClick: () => onOpen(lead) }, t(ns('button')))) : null));
export default WithdrawalBlock;
